var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"mb-2"},[_c('b-col',[_c('b-button',{on:{"click":_vm.exportTransactions}},[_vm._v(_vm._s(_vm.$t("transactions.excel-export.btn")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }